import { apiUrl } from './tool'
import axios from 'axios'
import { ALL_PERMISSION_CODES } from '@/constants/permissions'

const useMock = false

export function loginAPI(data) {
  if (useMock) {
    // Mock 主權限帳號（擁有所有權限）
    const mockUser = {
      "clinic_code": "0000000088",
      "clinic_name": "Dent&Co Clinic",
      "doctor_code": "",
      "doctor_name": "",
      "type": "1",
      "kind": "1",
      "token": "MDAwMDAwMDA4OGNkMzliYTE1ZWRiMzI0MzAyMDI1MTEyMw==",
      "plan": "99",
      "permissions": [
        "line_appointment",
        "web_appointment",
        "adv_page",
        "guide_to_line",
        "google_map_appointment",
        "adv_review_with_ai",
        "free_google_map_appointment"
      ],
      "crm_user_name": "測試1",  // 使用者名稱
      "is_root": false,  // 主權限標記
      "route_permissions": ["patients", "message", "upload"],  // 一般帳號權限範例
      "messages": "\u6210\u529f"
    }

    return Promise.resolve({ data: mockUser })
  }
  const url = apiUrl('login')
  return axios.post(url, data)
}

export function sendOtpAPI(data) {
  if (useMock) {
    return Promise.resolve({
      data: {
        prefix: "test",
        code: 123
      }
    })
  }
  const url = 'https://api.dentco.tw/api/v1/otps'
  return axios.post(url, data)
}

export function searchClinicAPI(params) {
  if (useMock) {
    return Promise.resolve({
      data: [
        {
          "clinic_code": "0000000000",
          "clinic_name": "Dent&Co測試牙醫診所",
          "address": "新北市新店區"
        },
        {
          "clinic_code": "0000000099",
          "clinic_name": "業務測試診所",
          "address": "臺北市信義區"
        }
      ]
    })
  }
  const url = apiUrl('register', 'clinic_list')
  return axios.get(url, {params})
}

export function registerDoctorAPI(data) {
  if (useMock) {
    return Promise.resolve({
      data: {
        "messages": "成功"
      }
    })
  }
  const url = apiUrl('register', 'doctor')
  return axios.post(url, data)
}

export function forgetPasswordAPI(data) {
  if (useMock) {
    return Promise.resolve({
      data: {
        "messages": "成功"
      }
    })
  }
  const url = apiUrl('register', 'forgot_password')
  return axios.post(url, data)
}

export function accountSettingAPI(data) {
  if (useMock) {
    return Promise.resolve({
      data: {
        "messages": "成功"
      }
    })
  }
  const url = apiUrl('account', 'setting')
  return axios.post(url, data)
}

export function switchAccountAPI(data) {
  if (useMock) {
    return Promise.resolve({
      data: {
        "messages": "成功"
      }
    })
  }
  const url = apiUrl('switch_account')
  return axios.post(url, data)
}

